"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const nosamedaydelivery = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-nosamedaydelivery" : '') + (description ? " desc-nosamedaydelivery" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-nosamedaydelivery"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-nosamedaydelivery"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.805.47a.752.752 0 0 1 0 1.063L1.76 23.578a.752.752 0 0 1-1.063-1.063L22.742.47a.751.751 0 0 1 1.063 0ZM12.25.693l5.29 2.116a.752.752 0 0 1-.559 1.395L12.25 2.312 9.74 3.316l4.804 2.002a.752.752 0 1 1-.578 1.388L7.954 4.2a.752.752 0 0 1-.173-.1L4.114 5.567l6.954 3.272a.752.752 0 0 1-.64 1.36L2.982 6.695v2.323a.752.752 0 1 1-1.503 0V5.002L12.25.693Zm10.522 5.57a.75.75 0 0 1 .751.75V19.08l-11.288 3.763-4.257-1.597a.751.751 0 1 1 .528-1.407l2.992 1.122v-3.425a.752.752 0 1 1 1.503 0v3.467l9.019-3.006V7.014c0-.415.337-.752.752-.752ZM.47 10.787a.752.752 0 0 1 .97-.433l5.04 1.928a.752.752 0 0 1-.537 1.404l-5.04-1.928a.752.752 0 0 1-.433-.97Zm.561 4a.752.752 0 0 1 .97-.433l2.52.964a.752.752 0 0 1-.536 1.404l-2.52-.964a.752.752 0 0 1-.434-.97ZM.1 17.752a.752.752 0 0 1 1.003-.351l1.01.486a.752.752 0 0 1-.653 1.354l-1.01-.486a.752.752 0 0 1-.35-1.003Z"
  }));
};
var _default = exports.default = nosamedaydelivery;